import { type AxisValue } from '@ifixit/helpers';
import { cn } from '@ifixit/ui/lib/utils';

/**
 * Per-axis store-offer subtext (issue #55186) shared by all search surfaces.
 * Joins each axis's value with ' / ' under the card title. PHP emits the axes
 * in display order (split axes lead) so the FE just renders. Returns null on
 * an empty/suppressed set so callers render unconditionally.
 */
export interface AxisValuesProps {
   axisValues?: AxisValue[] | null;
   className?: string;
}

// condition_code "0" is the default "New" -- noise on every card, so suppress it.
const SUPPRESSED_VALUES = new Set(['condition_code:0']);

export function AxisValues({ axisValues, className }: AxisValuesProps) {
   const labels = (axisValues ?? []).flatMap(axis => {
      const value = axis.values[0];
      if (!value || SUPPRESSED_VALUES.has(`${axis.axis_code}:${value.raw_value}`)) {
         return [];
      }
      return [value.value];
   });

   if (labels.length === 0) {
      return null;
   }

   return (
      <p className={cn('text-sm text-muted-foreground', className)} data-testid="axis-values">
         {labels.join(' / ')}
      </p>
   );
}
